import { Alert, AlertIcon, AlertTitle, Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export function TestnetOnlyNotice() {
  const { t } = useTranslation()

  return (
    <Box w="full" py={{ base: 8, md: 12 }}>
      <Alert
        status="info"
        bg="var(--testnet-accent, #e74c3c)"
        color="white"
        borderRadius="lg"
        boxShadow="sm"
        maxW="container.md"
        mx="auto"
        px={{ base: 4, md: 6 }}
        py={{ base: 3, md: 4 }}
      >
        <AlertIcon color="white" />
        <AlertTitle fontSize={{ base: 'sm', md: 'md' }}>
          {t('featureTestnetOnly')}
        </AlertTitle>
      </Alert>
    </Box>
  )
}
